import { render, staticRenderFns } from "./TheNotesFilter.vue?vue&type=template&id=08a40a32&scoped=true"
import script from "./TheNotesFilter.vue?vue&type=script&lang=js"
export * from "./TheNotesFilter.vue?vue&type=script&lang=js"
import style0 from "./TheNotesFilter.vue?vue&type=style&index=0&id=08a40a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a40a32",
  null
  
)

export default component.exports